






















import { Component, Vue } from 'vue-property-decorator'


@Component
export default class LoginCard extends Vue {
    loading = false
    username: string|null = null
    password: string|null = null

    get loginPayload() {
        return {
            username: this.username,
            password: this.password
        }
    }

    get errorMessage() {
        return this.$store.state.authErrorMessage
    }

    async submit() {
        if (!this.loading) {
            this.loading = true
            try {
                await this.$store.dispatch('login', this.loginPayload)
                this.loading = false
            } catch(e) {
                this.loading = false
            }
        }
    }
}
